import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { addMonths, format } from 'date-fns';
import { PreviousJobs } from 'server/shared/collections/previousJobs';
import { Organisation } from 'server/shared/models/organisation';
import { PreviousJobsDepartmentEmployment } from 'server/shared/models/previousJob';
import { PoolerUser } from 'server/shared/models/user';
import { dbDayDateToken } from 'server/static/dbDayDateToken';
import { OrganisationService } from '../../services/organisation.service';

interface PreviousEmploymentForLogSheet
  extends PreviousJobsDepartmentEmployment {
  department: {
    id: string;
    displayName: string;
  };
}
@Component({
  selector: 'previous-jobs-log-sheet',
  templateUrl: 'previous-jobs-employments-log-sheet.html',
  styleUrls: ['previous-jobs-employments-log-sheet.scss'],
})
export class PreviousJobsEmploymentsLogSheetComponent
  implements OnInit, OnDestroy
{
  organisation?: Organisation;
  departmentName: string = '';

  recentEmployments: PreviousEmploymentForLogSheet[] = [];
  oldEmployments: PreviousEmploymentForLogSheet[] = [];

  countInOrganisation: number = 0;
  countInDepartment: number = 0;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      user?: PoolerUser;
      email?: string;
      name?: string;
      departmentId: string;
    },
    private ngZone: NgZone,
    private organisationService: OrganisationService,
  ) {}

  isLoading = true;

  async ngOnInit() {
    const organisationAndDepartment =
      await this.organisationService.getOrganisationAndDepartmentById(
        this.data.departmentId,
      );
    if (!organisationAndDepartment) return;
    const { organisation, department } = organisationAndDepartment;
    this.organisation = organisation;
    this.isLoading = false;
    Tracker.autorun(() => {
      if (!this.data.departmentId) return;

      this.departmentName = department?.name || '';
      const previousJobsOfUser = PreviousJobs.findOne({
        $or: [
          {
            email: this.data?.email || '',
            fullName: this.data?.name || '',
          },
          {
            userId: this.data?.user?._id || '',
          },
        ],
        [`organisations.departments.id`]: this.data.departmentId,
      });
      if (!previousJobsOfUser) return;

      let previousJobOrganisation = previousJobsOfUser.organisations.find(
        (organisation) =>
          organisation.departments.some(
            (department) => department.id === this.data.departmentId,
          ),
      );

      let allRelevantEmployments: PreviousEmploymentForLogSheet[] = [];

      previousJobOrganisation?.departments?.forEach((department) => {
        allRelevantEmployments = [
          ...allRelevantEmployments,
          ...department.employments.map((employment) => ({
            ...employment,
            department: {
              id: department.id,
              displayName: department.displayName || '',
            },
          })),
        ];
      });

      allRelevantEmployments.forEach((employment) => {
        if (
          employment.endDate > format(addMonths(new Date(), -3), dbDayDateToken)
        ) {
          this.recentEmployments.push(employment);
        } else {
          this.oldEmployments.push(employment);
        }
      });
      this.countInOrganisation = this.recentEmployments.length;
      this.countInDepartment = this.recentEmployments.filter(
        (j) => j.department.id === this.data.departmentId,
      ).length;
    });
  }

  ngOnDestroy() {}
}
